// --------------------------------------------------------------
// Created On: 2023-02-21
// Author: Zachary Thomas
//
// Last Modified: 2023-09-05
// Modified By: Zachary Thomas
//
// Copyright 2023 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import { MAX_VIEW_ATTRIBUTES } from "../../constants/miscellaneous";

// Explains what a view is.
export default function HelpView(): Component {
  return (
    <div>
      <p className="px-3 my-2">
        Views allow users to control the data they want to focus on when looking at an asset group.
      </p>

      <p className="px-3 mt-3 mb-2">
        <b>Shared View:</b> By default, views are only accessible by the user who created them.
        Shared views can be used by any user in the company.
      </p>

      <p className="px-3 mt-3 mb-2">
        <b>Attributes:</b> The attributes selected will determine what data to show for each asset
        in the view. A view is limited to containing at most {`${MAX_VIEW_ATTRIBUTES} `}
        attributes.
      </p>
      <p className="px-3 mt-3 mb-2">
        <b>Highlighting Rules:</b> Attribute values can be highlighted dynamically based on custom
        rules. If one value would be highlighted by two separate rules, the rule higher in the list
        will take priority.
      </p>
    </div>
  );
}
